import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import CheckBoxHookForm_2 from "../../../../../components/CheckBoxHookForm_2";
import SelectHookFormSingle from "../../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useStates } from "../../../../CarrierAgreementMgmt/hooks/useStates";
import { IAgencyMappingsDetails } from "../types";

interface AgencyMappingsDetailsProps {
  rowForEdit: IAgencyMappingsDetails | undefined;
}
const AgencyMappingDetails: React.FC<AgencyMappingsDetailsProps> = ({
  rowForEdit,
}) => {
  const { register } = useFormContext();
  const formMethods = useFormContext();

  const { data: states, isLoading: statesLoading } = useStates();
  const stateOptions = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });
  const allStatesOpt = stateOptions && [...stateOptions];

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-1 md:grid-cols-3 mx-3 pb-2 gap-2 gap-x-2 py-2">
            <div className="my-1 mx-3">
              <TextInputLabelHookForm
                name="agencyName"
                label="Agency Name"
                type="text"
                required={true}
                className={
                  formMethods.formState.errors.agencyName &&
                  formMethods.formState.errors.agencyName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("agencyName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="my-1 mx-3">
              <TextInputLabelHookForm
                name="agencyStandard"
                label="Agency Standard"
                type="text"
                required={true}
                className={
                  formMethods.formState.errors.agencyStandard &&
                  formMethods.formState.errors.agencyStandard.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("agencyStandard", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="my-1 mx-3">
              <TextInputLabelHookForm
                name="agencySource"
                label="Agency Source"
                type="text"
                required={true}
                className={
                  formMethods.formState.errors.agencySource &&
                  formMethods.formState.errors.agencySource.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("agencySource", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>
            <div className="my-1 mx-3">
              <Controller
                name="state"
                control={formMethods.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                    }}
                    value={field.value}
                    isLoading={statesLoading}
                    options={allStatesOpt}
                    label="State"
                    className={
                      formMethods.formState.errors.state &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    required={true}
                  />
                )}
              />
            </div>
            <div className="col-span-2 my-1 ml-4">
              <CheckBoxHookForm_2
                name="isActive"
                label="Inactive Agency Mapping:"
                type="checkbox"
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                hasPermission
                disabled={false}
                className={
                  formMethods.formState.errors.isActive &&
                  formMethods.formState.errors.isActive.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={register}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgencyMappingDetails;
